<template>
  <div class="color-select">
    <div class="color-select__colors">
      <button
        type="button"
        class="color-select__color colorItem"
        v-for="value in colors"
        v-bind:key="value"
        v-bind:class="{ outline: color === value }"
        v-bind:style="{ background: value }"
        v-on:click="click(value)" />
    </div>
    <p
      class="color-select__violation"
      role="alert"
      v-for="violationText in violations"
      v-bind:key="violationText"
    >{{ violationText }}</p>
  </div>
</template>

<script>
export default {
  methods: {
    click(value) {
      this.$emit('change-color', value);
    },
  },
  props: {
    colors: { type: Array, required: true },
    color: { type: String, default: () => '' },
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    violations: {
      default: () => [],
      type: Array,
    },
  },
  name: 'ColorSelect',
};
</script>

<style scoped lang="scss">
.color-select {
  &__colors {
    flex: 1;
    max-width: 555px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }
  &__color {
    min-width: 36px;
    width: 36px;
    height: 36px;
    min-height: 36px;
    border-radius: 50%;
    margin: 5px 5px 5px 5px;
    cursor: pointer;
    transition: border-width 0.1s;
    &.outline {
      border: 4px solid #c2cfe0;
    }
    &:hover {
      border: 4px solid #c2cfe0;
    }
  }
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
}
</style>
